export default {

  SET_SELECT_MEMBER({commit},Member){
      commit('SET_SELECT_MEMBER',Member)
  },
  SET_RESULT({commit},result){
      commit('SET_RESULT',result)
  },
  SET_EDIT_MEMBER({commit},editMember){
      commit('SET_EDIT_MEMBER',editMember)
  },
}